module.exports = __webpack_public_path__ + "img/application.530d39d2.svg";